
import { Component, Mixins } from "vue-property-decorator";
import { mapState } from "vuex";
import AuthenticateMixin from "../../common/mixins/auth.mixin";
import { OfficeDto } from "@/types/office.type";
import { EmployeeDto } from "@/types/user.type";
import EmployeeCard from "./components/employee-card.vue";
import EmployeeDetails from "@/common/components/employee/employee-details.vue";
import { PositionDto } from "@/types/position.type";
import { SelectListOption } from "@/types/common.type";

@Component({
  components: {
    EmployeeCard,
    EmployeeDetails
  },  
  computed: {
    ...mapState("Shift", ["selectedOffice", "offices"]),
    ...mapState("DentalTemp", ["employees"]),
    ...mapState("OfficeProfile", ["positions"])
  }
})

export default class DentalTempComponent extends Mixins(AuthenticateMixin) {
  loading = false;
  nameFilter = "";
  offices!: OfficeDto[];
  selectedOffice!: OfficeDto;
  employees!: EmployeeDto[];

  positions!: PositionDto[];
  selectedPositions: SelectListOption[] = [];

  currentEmployee : { userId: number, practiceId: number } | null = null;
  isEmployeeDetailsVisible = false;

  get isOfficeSelectorDisabled(): boolean {
    return this.offices.length <= 1;
  }

  get favoriteUsers(): EmployeeDto[] {
    return this.employees.sort((a: EmployeeDto, b: EmployeeDto) =>
      a.lastName.localeCompare(b.lastName) || a.firstName.localeCompare(b.firstName)
    ).filter(x => x.isFavorite);
  }

  get regularUsers(): EmployeeDto[] {
    var nameFilter = this.nameFilter && this.nameFilter.toLowerCase();

    return this.employees.filter(
      x => !x.isFavorite &&
           (!nameFilter || (x.firstName + x.lastName).toLowerCase().indexOf(nameFilter) != -1) &&
           (this.selectedPositions.length == 0 || x.positions.some(p => this.selectedPositions.map(sp => sp.text).indexOf(p) > -1))
    );
  }

  get positionOptions(): SelectListOption[] {
    return this.positions.map(position => ({
      text: position.name,
      value: position.id
    } as SelectListOption))
  }

  async mounted(): Promise<void> {
    this.loading = true;

    if (this.offices.length == 0) {
      await this.$store.dispatch("Shift/getOffices", { userId: this.userInfo()?.sub });
    }
    await this.$store.dispatch("OfficeProfile/getPositions");
    await this.fetchData();

    this.loading = false;
  }

  async onOfficeSelect(value: OfficeDto): Promise<void> {
    this.$store.commit("Shift/updateField", {
      path: "selectedOffice",
      value: value
    });
    await this.fetchData();
  }

  async fetchData(): Promise<void> {
    this.loading = true;
    await this.$store.dispatch("DentalTemp/getAllEmployees");
    await this.$store.dispatch("DentalTemp/getOfficeEmployees", this.selectedOffice.id);
    this.loading = false;
  }

  onFavoriteChange(input: { isFavorite: boolean, rating: number }): void {
    var emp = this.employees.find(x => x.id == this.currentEmployee?.userId);
    if (emp) {
      emp.isFavorite = input.isFavorite;
      emp.rating = input.rating;
    }
  }

  showDetails(employeeId: number): void {
    this.currentEmployee = { userId: employeeId, practiceId: this.userInfo()?.practiceId ?? 0 };
    this.isEmployeeDetailsVisible = true;
  }
}

